import React from 'react'
import { CompareCredit } from '../../../types/compare-credit'

export const ArticleLinkedData = (props: { tip: CompareCredit.TipV2 }) => {
  const { tip } = props

  const data = {
    '@context': 'https://schema.org',
    '@type': 'NewsArticle',
    headline: tip.seoTitle,
    description: tip.seoDescription,
    image: [tip.image],
    datePublished: tip._createdAt,
    dateModified: tip._updatedAt,
    author: [
      {
        '@type': 'Person',
        name: tip.author[0].name,
      },
    ],
  }
  return (
    <script
      key={`jsonLd-${tip.slug}`}
      type="application/ld+json"
      dangerouslySetInnerHTML={{ __html: JSON.stringify(data) }}
    />
  )
}
